import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ICampus } from '../../../models/campuses.model';
import { doCheckCampusUrl } from '../../../store/campus.slice';
import { doGetStaffs } from '../../../store/staff.slice';
import { doGetGroups } from '../../../store/group.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import moment from 'moment';
import qs from 'qs';
import _ from 'lodash';

import { useSnackbar } from 'notistack';
import {
  Button as AntButton,
  DatePicker,
  Descriptions,
  Modal,
  Select,
  Table,
  TableColumnsType,
} from 'antd';

import { CgCloseR } from 'react-icons/cg';
import Loader from '../../Loader';
import Pagination from '../../Pagination';
import Button from '../../Button';
import Checkbox from '../../Checkbox';
import Radio from '../../Radio';
import FileUpload from '../../FileUpload';
import EditArea from './EditArea';
import config from '../../../lib/config';
import SearchPostcodeModal from '../../modals/SearchPostcodeModal';
import {
  errorVariant,
  infoVariant,
  warningVariant,
} from '../../../lib/barVariant';
import useAuth from '../../../hooks/useAuth';
import useNotification from '../../../hooks/useNotification';

const { Option } = Select;

interface IProps {
  campus: ICampus | null;
  onSubmit: Function;
}

interface IColumns {
  memberCode: string;
  memberName: string;
  memberEngName: string;
  groupNo: string;
}

const BusinessCampusEditor: FC<IProps> = ({ campus, onSubmit }) => {
  const { writeAuthYn } = useAuth();
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { infoNotification } = useNotification();
  const dispatch = useDispatch();
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // CA0001 = 학원상태
  const CA0001 = commonCodes.find(
    (item) => item.commonCode === 'CA0001',
  )?.detailCode;
  // CA0003 = 학원구분
  const CA0003 = commonCodes.find(
    (item) => item.commonCode === 'CA0003',
  )?.detailCode;
  // SY0004 = 지역코드
  const SY0004 = commonCodes.find(
    (item) => item.commonCode === 'SY0004',
  )?.detailCode;

  const { staffs, isLoading: staffLoading } = useSelector(
    (state: RootState) => state.staff,
  );
  const { groups, isLoading: groupLoading } = useSelector(
    (state: RootState) => state.group,
  );
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const [name, setName] = useState('');
  const [engName, setEngName] = useState('');
  const [isTestCampus, setIsTestCampus] = useState(false);
  const [url, setUrl] = useState('');
  const [isUrlChecked, setIsUrlChecked] = useState(false);
  const [principal, setPrincipal] = useState('');
  const [phone, setPhone] = useState('');
  const [tel, setTel] = useState('');
  const [fax, setFax] = useState('');
  const [email, setEmail] = useState('');
  const [contractDate, setContractDate] = useState('');
  const [openDate, setOpenDate] = useState('');
  const [campusDiv, setCampusDiv] = useState<any>(null);
  const [campusDivList, setCampusDivList] = useState<any>([]);
  const [padUseYn, setPadUseYn] = useState<any>('Y');
  const [zipcode, setZipcode] = useState('');
  const [address, setAddress] = useState('');
  const [detailedAddress, setDetailedAddress] = useState('');
  const [region, setRegion] = useState<any>(null);
  const [regionList, setRegionList] = useState<any>([]);
  const [coords, setCoords] = useState<any>([]);
  const [file1, setFile1] = useState<any>(null);
  const [file1Info, setFile1Info] = useState<any>(null);
  const [file1Code, setFile1Code] = useState<any>(null);
  const [file2, setFile2] = useState<any>(null);
  const [file2Info, setFile2Info] = useState<any>(null);
  const [file2Code, setFile2Code] = useState<any>(null);
  const [status, setStatus] = useState<any>(null);
  const [statusList, setStatusList] = useState<any>([]);
  const [closeReason, setCloseReason] = useState('');
  const [closeDate, setCloseDate] = useState('');
  const [agent, setAgent] = useState<any>();
  const [agents, setAgents] = useState<any>();
  const [page, setPage] = useState(1);
  const [field, setField] = useState<any>();
  const [keyword, setKeyword] = useState('');
  const [param, setParam] = useState({});
  const [ips, setIps] = useState<string[]>([]);

  const [corporateRegistrationNo, setCorporateRegistrationNo] = useState('');
  const [campusRegistNo, setCampusRegistNo] = useState('');
  const [ceoName, setCeoName] = useState('');
  const [onlineRetailRegistrationNumber, setOnlineRetailRegistrationNumber] = useState('');
  const [file3, setFile3] = useState<any>(null);
  const [file3Info, setFile3Info] = useState<any>(null);
  const [file3Code, setFile3Code] = useState<any>(null);
  const [file4, setFile4] = useState<any>(null);
  const [file4Info, setFile4Info] = useState<any>(null);
  const [file4Code, setFile4Code] = useState<any>(null);

  const [postcodeVisible, setPostcodeVisible] = useState(false);
  const [mapVisible, setMapVisible] = useState(false);
  const [selectAgentVisible, setSelectAgentVisible] = useState(false);

  const nameInput = useRef<any>();
  const engNameInput = useRef<any>();
  const urlInput = useRef<any>();
  const principalInput = useRef<any>();
  const phoneInput = useRef<any>();
  const emailInput = useRef<any>();
  const closeReasonInput = useRef<any>();

  useEffect(() => {
    if (CA0001) {
      const _statusList: any = [];
      const _CA0001 = [...CA0001].sort((a, b) =>
        a.orderSeq < b.orderSeq ? -1 : a.orderSeq > b.orderSeq ? 1 : 0,
      );
      _CA0001.forEach((item: any) => {
        _statusList.push({
          label: item.korName,
          value: item.detailCode,
        });
      });
      setStatusList(_statusList);
      setStatus(_statusList[0].value);
    }

    if (CA0003) {
      const list: any = [];
      const _CA0003 = [...CA0003].sort((a, b) =>
        a.orderSeq < b.orderSeq ? -1 : a.orderSeq > b.orderSeq ? 1 : 0,
      );
      _CA0003.forEach((item: any) => {
        list.push({
          label: item.korName,
          value: item.detailCode,
        });
      });
      setCampusDivList(list);
      setCampusDiv(list[0].value);
    }

    if (SY0004) {
      const _regionList: any = [];
      SY0004.forEach((item: any) => {
        _regionList.push({
          label: item.korName,
          value: item.detailCode,
        });
      });
      setRegionList(_regionList);
      setRegion(_regionList[0].value);
    }
  }, [commonCodes]);

  // for editing
  useEffect(() => {
    console.log(campus);
    if (campus && staffs) {
      setName(campus.campusKorName || '');
      setEngName(campus.campusEngName || '');
      setIsTestCampus(campus.testYn === 'Y' ? true : false);
      setUrl(campus.url || '');
      setIsUrlChecked(true);
      setPrincipal(campus.representName || '');
      setPhone(campus.mobilePhone || '');
      setTel(campus.telephoneNo || '');
      setFax(campus.faxNo || '');
      setEmail(campus.email || '');
      setPadUseYn(campus.padUseYn || '');
      setZipcode(campus.zipNo || '');
      setAddress(campus.address || '');
      setDetailedAddress(campus.detailAddress || '');
      setFile1Info(campus.contractFile || null);
      setFile1Code(campus.contractFile?.attachFileCode || null);
      setFile2Info(campus.registrationFile || null);
      setFile2Code(campus.registrationFile?.attachFileCode || null);
      setCloseReason(campus.terminationReason || '');
      setCorporateRegistrationNo(campus.corporateRegistrationNo || '');
      setCampusRegistNo(campus.campusRegistNo || '');
      setCeoName(campus.ceoName || '');
      setFile3Info(campus.hpFile || null);
      setFile3Code(campus.hpFile?.attachFileCode || null);
      setFile4Info(campus.mobileHpFile || null);
      setFile4Code(campus.mobileHpFile?.attachFileCode || null);
      setOnlineRetailRegistrationNumber(campus.onlineRetailRegistrationNumber || '')

      if (campus.contractDate) {
        setContractDate(
          `${campus.contractDate.slice(0, 4)}-${campus.contractDate.slice(
            4,
            6,
          )}-${campus.contractDate.slice(6)}`,
        );
      } else {
        setContractDate('');
      }

      if (campus.openDate) {
        setOpenDate(
          `${campus.openDate.slice(0, 4)}-${campus.openDate.slice(
            4,
            6,
          )}-${campus.openDate.slice(6)}`,
        );
      } else {
        setOpenDate('');
      }

      if (campus.cancelDate) {
        setCloseDate(
          `${campus.cancelDate.slice(0, 4)}-${campus.cancelDate.slice(
            4,
            6,
          )}-${campus.cancelDate.slice(6)}`,
        );
      } else {
        setCloseDate('');
      }

      setCampusDiv(campus.campusDiv);
      setRegion(campus.sidoCode);

      if (campus.regions) {
        const regions = [...campus.regions];
        regions.sort((a, b) =>
          a.mapSeq < b.mapSeq ? -1 : a.mapSeq > b.mapSeq ? 1 : 0,
        );
        const _coords: any = [];
        regions.forEach((item) =>
          _coords.push({
            lat: item.latitude,
            lng: item.longitude,
          }),
        );
        setCoords(_coords);
      } else {
        setCoords([]);
      }

      setStatus(campus.campusStatus);

      if (campus.managerMemberCode) {
        const staff = staffs.find(
          (item) => item.memberCode === campus.managerMemberCode,
        );
        if (staff) setAgent(staff);
      }

      if (campus.ips) {
        const campusIps = [...campus.ips];
        campusIps.sort((a, b) =>
          a.ipCode < b.ipCode ? -1 : a.ipCode > b.ipCode ? 1 : 0,
        );
        const _ips: any = [];
        campusIps.forEach((item) => _ips.push(item.campusIp));
        setIps(_ips);
      } else {
        setIps([]);
      }
    }
  }, [campus, staffs]);

  useEffect(() => {
    if (staffs && groups && campusData?.length > 0) {
      // query to state
      if (query.page) {
        setPage(Number(query.page));
      }
      if (query.field) {
        setField(String(query.field));
      }
      if (query.keyword) {
        setKeyword(String(query.keyword));
      }

      // data filtering
      let data: any = _.cloneDeep(staffs);
      // 본사 직원 필터링
      data = data.filter(
        (item: any) => item.campusCode === campusData[0].campusCode,
      );
      // 그룹 영문명 삽입
      data.forEach((item: any) => {
        groups.forEach((group) => {
          if (item.groupNo === String(group.groupNo)) {
            item.groupEngName = group.engName;
          }
        });
      });

      if (query.field && query.keyword) {
        if (query.field === 'group') {
          data = data.filter(
            (item: any) =>
              item.groupName?.indexOf(String(query.keyword)) !== -1,
          );
        } else if (query.field === 'name') {
          data = data.filter(
            (item: any) =>
              item.memberName?.indexOf(String(query.keyword)) !== -1,
          );
        }
      }

      setAgents(data);
    }
  }, [location, staffs, groups, campusData]);

  useEffect(() => {
    setField('group');
    getStaffs();
    getGroups();
  }, []);

  const getStaffs = async () => {
    const res = await dispatch(doGetStaffs());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      case 404:
        enqueueSnackbar(t('common.message.notFound'), warningVariant);
        break;
      default:
        enqueueSnackbar(
          res?.data?.data || t('common.message.error'),
          errorVariant,
        );
    }
  };

  const getGroups = async () => {
    const res = await dispatch(doGetGroups());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(
          res?.data?.data || t('common.message.error'),
          errorVariant,
        );
    }
  };

  const checkUrl = async (url: string) => {
    if (!url) return;

    const res = await dispatch(doCheckCampusUrl(url));

    switch (res?.status) {
      case 200:
        setIsUrlChecked(true);
        break;
      case 400:
        setIsUrlChecked(false);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(
          res?.data?.data || t('common.message.error'),
          errorVariant,
        );
    }
  };

  const onSetUrl = (value: string) => {
    setUrl(value);
    checkUrl(value);
  };

  const onCompletePostcode = (data: any) => {
    const _address =
      data.userSelectedType === 'R'
        ? data.buildingName
          ? `${data.roadAddress} (${data.buildingName})`
          : data.roadAddress
        : data.jibunAddress;
    setAddress(_address);
    setZipcode(data.zonecode);
    setPostcodeVisible(false);
  };

  const onAddIp = () => {
    const _ips = [...ips];
    _ips.push('');
    setIps(_ips);
  };

  const onDeleteIp = (index: number) => {
    const _ips = [...ips];
    _ips.splice(index, 1);
    setIps(_ips);
  };

  const onSetIp = (index: number, value: string) => {
    const _ips = [...ips];
    _ips[index] = value;
    setIps(_ips);
  };

  const onSave = async () => {
    if (!name) {
      nameInput.current.focus();
      return enqueueSnackbar(t('business.campus.message1'), infoVariant);
    }
    if (!engName) {
      engNameInput.current.focus();
      return enqueueSnackbar(t('business.campus.1'), infoVariant);
    }
    if (!url) {
      urlInput.current.focus();
      return enqueueSnackbar(t('business.campus.message2'), infoVariant);
    }
    if (!isUrlChecked) {
      urlInput.current.focus();
      return enqueueSnackbar(t('business.campus.message3'), infoVariant);
    }
    if (!principal) {
      principalInput.current.focus();
      return enqueueSnackbar(t('business.campus.message4'), infoVariant);
    }
    if (!phone) {
      phoneInput.current.focus();
      return enqueueSnackbar(t('business.campus.message5'), infoVariant);
    }
    if (!email) {
      emailInput.current.focus();
      return enqueueSnackbar(t('business.campus.message6'), infoVariant);
    }
    const regex = /.+@.+/;
    if (!regex.test(email)) {
      emailInput.current.focus();
      return enqueueSnackbar(t('business.campus.message7'), infoVariant);
    }
    if (!contractDate) {
      return enqueueSnackbar(t('business.campus.message8'), infoVariant);
    }
    if (status?.value === statusList[1]?.value) {
      if (!closeDate) {
        return enqueueSnackbar(t('business.campus.message9'), infoVariant);
      }
      if (!closeReason) {
        closeReasonInput.current.focus();
        return enqueueSnackbar(t('business.campus.message10'), infoVariant);
      }
    }

    const form = new FormData();
    form.append('campusKorName', name);
    form.append('campusEngName', engName);
    form.append('testYn', isTestCampus ? 'Y' : 'N');
    form.append('hqYn', 'Y');
    form.append('url', url);
    form.append('representName', principal);
    form.append('mobilePhone', phone);
    form.append('email', email);
    form.append(
      'contractDate',
      contractDate.slice(0, 4) +
        contractDate.slice(5, 7) +
        contractDate.slice(8),
    );
    form.append('campusDiv', campusDiv);
    form.append('padUseYn', padUseYn);
    form.append('sidoCode', region);
    form.append('campusStatus', status);

    if (tel) form.append('telephoneNo', tel);
    if (fax) form.append('faxNo', fax);
    if (openDate)
      form.append(
        'openDate',
        openDate.slice(0, 4) + openDate.slice(5, 7) + openDate.slice(8),
      );
    if (address) form.append('address', address);
    if (detailedAddress) form.append('detailAddress', detailedAddress);
    if (zipcode) form.append('zipNo', zipcode);
    if (corporateRegistrationNo)
      form.append('corporateRegistrationNo', corporateRegistrationNo);
    if (campusRegistNo) form.append('campusRegistNo', campusRegistNo);
    if (ceoName) form.append('ceoName', ceoName);
    if (onlineRetailRegistrationNumber) form.append('onlineRetailRegistrationNumber', onlineRetailRegistrationNumber);
    if (coords?.length > 0) {
      const _coords: any = [];
      coords.forEach((coord: any, index: number) => {
        _coords.push({
          mapSeq: index + 1,
          latitude: String(coord.lat),
          longitude: String(coord.lng),
        });
      });
      form.append('regions', JSON.stringify(_coords));
    }
    if (status?.value === statusList[1]?.value) {
      form.append('terminationReason', closeReason);
      form.append(
        'cancelDate',
        closeDate.slice(0, 4) + closeDate.slice(5, 7) + closeDate.slice(8),
      );
    }
    if (agent) {
      form.append('managerMemberCode', agent.memberCode);
    }
    if (ips?.length > 0) {
      let isIpCorrect = true;
      ips.forEach((ip) => {
        const regex = /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/;
        if (!regex.test(ip)) isIpCorrect = false;
      });
      if (!isIpCorrect) {
        return enqueueSnackbar(t('business.campus.message11'), infoVariant);
      }
      form.append('ips', JSON.stringify(ips));
    }

    if (status === 'TM') {
      if (!closeReason) {
        return infoNotification(t('business.campus.2'));
      }
      form.append('terminationReason', closeReason);
      if (!closeDate) {
        return infoNotification(t('business.campus.3'));
      }
      form.append(
        'cancelDate',
        closeDate.slice(0, 4) + closeDate.slice(5, 7) + closeDate.slice(8),
      );
    }

    // 첨부파일 포함
    if (file1) form.append('contractFile', file1);
    if (file2) form.append('registrationFile', file2);
    if (file3) form.append('hpFile', file3);
    if (file4) form.append('mobileHpFile', file4);

    // 기존 첨부파일 처리
    if (campus) {
      // 계약서
      if (file1Code) form.append('contractFileCode', file1Code);

      // 1) 신규파일 있음
      if (file1) {
        if (file1Code) form.append('contractFileStatus', 'update');
        else form.append('contractFileStatus', 'create');
        // 2) 신규파일 없음, 기존파일 있음
      } else if (file1Code) {
        if (file1Info) form.append('contractFileStatus', 'keep');
        else form.append('contractFileStatus', 'delete');
        // 3) 신규파일 없음, 기존파일 없음
      } else {
        form.append('contractFileStatus', 'keep');
      }

      // 사업자등록증
      if (file2Code) form.append('registrationFileCode', file2Code);

      // 1) 신규파일 있음
      if (file2) {
        if (file2Code) form.append('registrationFileStatus', 'update');
        else form.append('registrationFileStatus', 'create');
        // 2) 신규파일 없음, 기존파일 있음
      } else if (file2Code) {
        if (file2Info) form.append('registrationFileStatus', 'keep');
        else form.append('registrationFileStatus', 'delete');
        // 3) 신규파일 없음, 기존파일 없음
      } else {
        form.append('registrationFileStatus', 'keep');
      }

      // 메인 페이지 (PC)
      if (file3Code) form.append('hpFileCode', file3Code);

      // 1) 신규파일 있음
      if (file3) {
        if (file3Code) form.append('hpFileStatus', 'update');
        else form.append('hpFileStatus', 'create');
        // 2) 신규파일 없음, 기존파일 있음
      } else if (file3Code) {
        if (file3Info) form.append('hpFileStatus', 'keep');
        else form.append('hpFileStatus', 'delete');
        // 3) 신규파일 없음, 기존파일 없음
      } else {
        form.append('hpFileStatus', 'keep');
      }

      // 메인 페이지 (Mobile)
      if (file4Code) form.append('mobileHpFileCode', file4Code);

      // 1) 신규파일 있음
      if (file4) {
        if (file4Code) form.append('mobileHpFileStatus', 'update');
        else form.append('mobileHpFileStatus', 'create');
        // 2) 신규파일 없음, 기존파일 있음
      } else if (file4Code) {
        if (file4Info) form.append('mobileHpFileStatus', 'keep');
        else form.append('mobileHpFileStatus', 'delete');
        // 3) 신규파일 없음, 기존파일 없음
      } else {
        form.append('mobileHpFileStatus', 'keep');
      }
    }

    onSubmit(form);
  };

  const renderGroupName = (groupNo: string) => {
    const group = groups?.find((item) => item.groupNo === Number(groupNo));
    let name = '';

    if (group) {
      if (i18n.language === 'ko') name = group.korName;
      else name = group.engName;
    }

    return name;
  };

  const onSearch = () => {
    const param: any = { page: 1 };

    if (field && keyword) {
      param.field = field;
      param.keyword = keyword;
    }

    setParam(param);
    history.push(`${window.location.pathname}?${qs.stringify(param)}`);
  };

  const onSelectAgent = (id: string) => {
    const _agent = agents.find((item: any) => item.memberCode === id);
    if (!_agent) return;
    setAgent(_agent);
    setSelectAgentVisible(false);
  };

  const fieldList = [
    { label: t('business.campus.column10'), value: 'group' },
    { label: t('business.campus.column11'), value: 'name' },
  ];

  const columns: TableColumnsType<IColumns> = [
    {
      title: t('business.campus.column10'),
      dataIndex: 'groupNo',
      key: 'groupNo',
      sorter: (a, b) => a.groupNo?.localeCompare(b.groupNo),
      render: (groupNo: string) => renderGroupName(groupNo),
    },
    {
      title: t('business.campus.column11'),
      dataIndex: 'memberName',
      key: 'memberName',
      sorter: (a, b) => a.memberName?.localeCompare(b.memberName),
    },
    {
      title: t('business.campus.column11'),
      dataIndex: 'memberEngName',
      key: 'memberEngName',
      sorter: (a, b) => a.memberEngName?.localeCompare(b.memberEngName),
    },
    {
      title: '',
      key: 'memberCode',
      dataIndex: 'memberCode',
      align: 'center',
      render: (memberCode: string) => (
        <div className="flex justify-content-center">
          <Button
            className="btn-basic small mint"
            onClick={() => onSelectAgent(memberCode)}
            text={t('common.button.select')}
          />
        </div>
      ),
    },
  ];
  if (i18n.language === 'ko') columns.splice(2, 1);
  else columns.splice(1, 1);

  return (
    <div>
      <div className="comm-bx__between">
        <h4>{t('business.campus.title3')}</h4>
      </div>
      <div className='comm-table__area rowType'>
      <Descriptions
        bordered
        size="small"
        column={2}
        labelStyle={{ width: '15%' }}
        contentStyle={{ width: '35%' }}
      >
        <Descriptions.Item label={`* ${t('business.campus.column2')}`}>
          <div className="flex comm-gap mb-2">
            <div className="">
              <input
                type="text"
                className="form-control input-text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                ref={nameInput}
              />
            </div>
            <div className="flex align-items-center">
              <Checkbox
                checked={isTestCampus}
                onChange={() => setIsTestCampus(!isTestCampus)}
                text={t('business.campus.column9')}
              />
            </div>
          </div>
          <span>&nbsp;* {t('business.campus.text4')}</span>
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.4')}`}>
          <input
            type="text"
            className="form-control input-text"
            value={engName}
            onChange={(e) => setEngName(e.target.value)}
            ref={engNameInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.column12')}`}>
          <input
            type="text"
            className="form-control input-text mb-2"
            value={url}
            onChange={(e) => onSetUrl(e.target.value)}
            ref={urlInput}
            readOnly={Boolean(campus)}
          />
          <span
            className={'check-result' +
              (campus?.url === url || !url
                ? ''
                : isUrlChecked
                ? ' text-success'
                : ' text-danger')
            }
          >
            &nbsp;
            {campus?.url === url
              ? t('business.campus.text1')
              : url
              ? isUrlChecked
                ? t('business.campus.text2')
                : t('business.campus.text3')
              : t('business.campus.message2')}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.column5')}`}>
          <input
            type="text"
            className="form-control input-text"
            value={principal}
            onChange={(e) => setPrincipal(e.target.value)}
            ref={principalInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.column13')}`}>
          <input
            type="text"
            className="form-control input-text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            ref={phoneInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('business.campus.column14')}>
          <input
            type="text"
            className="form-control input-text"
            value={tel}
            onChange={(e) => setTel(e.target.value)}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('business.campus.column15')}>
          <input
            type="text"
            className="form-control input-text"
            value={fax}
            onChange={(e) => setFax(e.target.value)}
          />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.column16')}`}>
          <input
            type="text"
            className="form-control input-text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            ref={emailInput}
          />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.column8')}`}>
          <div className="date-picker__area w-150p">
            <DatePicker
              className="w-100"
              value={contractDate ? moment(contractDate) : undefined}
              onChange={(e) => {
                if (e === null) setContractDate('');
                else setContractDate(moment(e).format('YYYY-MM-DD'));
              }}
            />
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('business.campus.column17')}>
          <div className="date-picker__area w-150p">
            <DatePicker
              className="w-100"
              value={openDate ? moment(openDate) : undefined}
              onChange={(e) => {
                if (e === null) setOpenDate('');
                else setOpenDate(moment(e).format('YYYY-MM-DD'));
              }}
            />
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.column18')}`}>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={campusDiv}
              onChange={(value) => setCampusDiv(value)}
            >
              {campusDivList?.map((item: any) => {
                return (
                  <Option key={String(item.value)} value={String(item.value)}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.column19')}`}>
          <div className="radio-wrapper">
            <Radio
              checked={padUseYn === 'Y'}
              onChange={() => setPadUseYn('Y')}
              text={t('common.option.yes')}
            />
            <Radio
              checked={padUseYn === 'N'}
              onChange={() => setPadUseYn('N')}
              text={t('common.option.no')}
            />
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('common.text.address1')} span={2}>
          <div className="comm-btn__area align-items-center">
            <Button
              className="btn-basic black"
              onClick={() => setPostcodeVisible(true)}
              text={t('common.button.address')}
            />
            {zipcode ? ` (${zipcode})` : ''} {address}
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('common.text.address2')} span={2}>
          <input
            type="text"
            className="form-control input-text"
            value={detailedAddress}
            onChange={(e) => setDetailedAddress(e.target.value)}
          />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('business.campus.column4')}`} span={2}>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={region}
              onChange={(value) => setRegion(value)}
            >
              {regionList?.map((item: any) => {
                return (
                  <Option key={String(item.value)} value={String(item.value)}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('business.campus.column20')} span={2}>
          <div className="comm-btn__area">
            <Button
              className="btn-basic black"
              onClick={() => setMapVisible(true)}
              text={t('business.campus.button2')}
            />
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('business.campus.column21')} span={2}>
          {file1Info ? (
            <div>
              <a
                className="download-link"
                href={`${file1Info.fileLocation}`}
                download={file1Info.originalName}
              >
                {file1Info.originalName}
              </a>
              <span className="ml-1 pointer" onClick={() => setFile1Info(null)}>
                <CgCloseR />
              </span>
            </div>
          ) : null}
          <FileUpload file={file1} setFile={setFile1} />
        </Descriptions.Item>
        <Descriptions.Item label={t('business.campus.column22')} span={2}>
          {file2Info ? (
            <div>
              <a
                className="download-link"
                href={`/${file2Info.fileLocation}`}
                download={file2Info.originalName}
              >
                {file2Info.originalName}
              </a>
              <span className="ml-1 pointer" onClick={() => setFile2Info(null)}>
                <CgCloseR />
              </span>
            </div>
          ) : null}
          <FileUpload file={file2} setFile={setFile2} />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('common.column.status')}`} span={2}>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={status}
              onChange={(value) => setStatus(value)}
            >
              {statusList?.map((item: any) => {
                return (
                  <Option key={String(item.value)} value={String(item.value)}>
                    {item.label}
                  </Option>
                );
              })}
            </Select>
          </div>
        </Descriptions.Item>
        {status === statusList[1]?.value ? (
          <>
            <Descriptions.Item
              label={`* ${t('business.campus.column23')}`}
              span={2}
            >
              <div className="date-picker__area">
                <DatePicker
                  value={closeDate ? moment(closeDate) : undefined}
                  onChange={(e) => {
                    if (e === null) setCloseDate('');
                    else setCloseDate(moment(e).format('YYYY-MM-DD'));
                  }}
                />
              </div>
            </Descriptions.Item>
            <Descriptions.Item
              label={`* ${t('business.campus.column24')}`}
              span={2}
            >
              <textarea
                rows={3}
                value={closeReason}
                onChange={(e) => setCloseReason(e.target.value)}
                ref={closeReasonInput}
              />
            </Descriptions.Item>
          </>
        ) : null}
        <Descriptions.Item label={t('business.campus.column1')} span={2}>
          <div className="flex align-items-center comm-gap">
            <div className="comm-btn__area">
              <Button
                className="btn-basic black"
                onClick={() => setSelectAgentVisible(true)}
                text={t('business.campus.button3')}
              />
            </div>
            <span>{agent ? agent.memberName : null}</span>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('business.campus.column25')} span={2}>
          {ips.length > 0
            ? ips.map((ip, index) => (
              <div className="comm-gap mb-2" key={index}>
                <div className="w-200">
                  <input
                    type="text"
                    className="form-control input-text"
                    value={ips[index]}
                    onChange={(e) => onSetIp(index, e.target.value)}
                  />
                </div>
                <div className="comm-btn__area">
                  <Button
                    className="btn-basic gray small"
                    onClick={() => onDeleteIp(index)}
                    text={t('common.button.delete')}
                  />
                </div>
              </div>
              ))
            : null}
          <div className="comm-btn__area">
            <Button
              className="btn-basic pink-line"
              onClick={onAddIp}
              text={t('common.button.add')}
            />
          </div>
        </Descriptions.Item>
      </Descriptions>
      </div>

      <div className="comm-bx__between">
        <h4>{t('business.campus.title4')}</h4>
      </div>
      <div className='comm-table__area rowType'>
        <Descriptions
          bordered
          size="small"
          column={3}
          labelStyle={{ width: '16.6%' }}
          contentStyle={{ width: '16.6%' }}
        >
          <Descriptions.Item label={t('business.campus.column26')}>
            <input
              type="text"
              className="form-control input-text"
              value={corporateRegistrationNo}
              onChange={(e) => setCorporateRegistrationNo(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('business.campus.column27')}>
            <input
              type="text"
              className="form-control input-text"
              value={campusRegistNo}
              onChange={(e) => setCampusRegistNo(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('business.campus.column28')}>
            <input
              type="text"
              className="form-control input-text"
              value={ceoName}
              onChange={(e) => setCeoName(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('business.campus.column29')} span={1}>
            {file3Info ? (
              <div>
                <a
                  className="download-link"
                  href={`${file3Info.fileLocation}`}
                  download={file3Info.originalName}
                >
                  {file3Info.originalName}
                </a>
                <span className="ml-1 pointer" onClick={() => setFile3Info(null)}>
                  <CgCloseR />
                </span>
              </div>
            ) : null}
            <FileUpload file={file3} setFile={setFile3} />
          </Descriptions.Item>
          <Descriptions.Item label={t('business.campus.column31')} span={2}>
            <input
              type="text"
              className="form-control input-text"
              value={onlineRetailRegistrationNumber}
              onChange={(e) => setOnlineRetailRegistrationNumber(e.target.value)}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('business.campus.column30')} span={3}>
            {file4Info ? (
              <div>
                <a
                  className="download-link"
                  href={`/${file4Info.fileLocation}`}
                  download={file4Info.originalName}
                >
                  {file4Info.originalName}
                </a>
                <span className="ml-1 pointer" onClick={() => setFile4Info(null)}>
                  <CgCloseR />
                </span>
              </div>
            ) : null}
            <FileUpload file={file4} setFile={setFile4} />
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            onClick={onSave}
            className="btn-basic pink"
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            onClick={() => history.push(`/business/campus${location.search}`)}
            className="btn-basic gray"
            text={t('common.button.cancel')}
          />
        </div>
      </div>

      {/* 주소검색 모달 */}
      {postcodeVisible && (
        <SearchPostcodeModal
          postcodeVisible={postcodeVisible}
          setPostcodeVisible={setPostcodeVisible}
          onCompletePostcode={onCompletePostcode}
        />
      )}

      {/* 지역권 설정 모달 */}
      <Modal
        title={t('business.campus.button2')}
        visible={mapVisible}
        onCancel={() => {
          sessionStorage.removeItem('coords');
          setMapVisible(false);
        }}
        // MapContainer width + 48px
        width={window.innerWidth - 552}
        destroyOnClose={true}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => {
                const coords: any = sessionStorage.getItem('coords');
                setCoords(JSON.parse(coords));
                setMapVisible(false);
              }}
            >
              {t('business.campus.button4')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => {
                sessionStorage.removeItem('coords');
                setMapVisible(false);
              }}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <EditArea
          coords={coords}
          address={address ? `${address} ${detailedAddress}` : null}
        />
      </Modal>

      {/* 직원 찾기 모달 */}
      <Modal
        className="select-agent-modal"
        title={t('business.campus.button3')}
        visible={selectAgentVisible}
        onCancel={() => setSelectAgentVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="submit"
              className='btn-basic gray'
              onClick={() => setSelectAgentVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>
        ]}
      >
        <div>
          {staffLoading || groupLoading ? <Loader /> : null}
          <div className="flex w-100 comm-gap">
            <div className="text-left" style={{ flex: 1 }}>
              <Select
                className="w-100"
                value={field}
                onChange={(value) => setField(value)}
              >
                {fieldList?.map((item: any) => {
                  return (
                    <Option key={String(item.value)} value={String(item.value)}>
                      {item.label}
                    </Option>
                  );
                })}
              </Select>
            </div>
            <div style={{ flex: 3 }}>
              <input
                type="text"
                className="form-control"

                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') onSearch();
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Button
                className="btn-basic black"
                onClick={onSearch}
                text={t('common.button.search')}
              />
            </div>
          </div>
          <div className='comm-table__area'>
            <Table
              columns={columns}
              dataSource={agents || undefined}
              pagination={{
                current: page,
                pageSize: config.miniPageSize,
              }}
            />
          </div>
          <div className="comm-bx__between">
            <div className="common-paging center">
              <Pagination
                count={agents?.length || 0}
                page={page}
                param={param}
                path={window.location.pathname}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default BusinessCampusEditor;
